// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/colors.css";
import ___CSS_LOADER_ICSS_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../styles/helpers.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_documentAlt.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_1___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__docLink___RU6c2 {
  cursor: pointer;
}

.styles__docLink___RU6c2::before {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left center;
  background-size: 18px;
  bottom: 0;
  content: '';
  display: inline-block;
  height: 24px;
  left: -32px;
  margin: auto;
  position: absolute;
  top: 0;
  width: 22px;
}

.styles__icon___xVwIL {
  box-shadow: none !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]};
  opacity: 0.7;
}

.styles__icon___xVwIL:hover {
    cursor: pointer;
  }
`, "",{"version":3,"sources":["webpack://./universal/components/S3FilePreview/styles.css"],"names":[],"mappings":"AAIA;EAEE,eAAe;AACjB;;AAEA;EACE,yEAAwE;EACxE,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,mDAAiB;EACjB,YAAY;AAId;;AAHE;IACE,eAAe;EACjB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n@value colors: \"styles/colors.css\";\n@value gtGrayDark from colors;\n\n.docLink {\n  composes: docLink from helpers;\n  cursor: pointer;\n}\n\n.docLink::before {\n  background: url('styles/img/icon_documentAlt.png') no-repeat left center;\n  background-size: 18px;\n  bottom: 0;\n  content: '';\n  display: inline-block;\n  height: 24px;\n  left: -32px;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  width: 22px;\n}\n\n.icon {\n  box-shadow: none !important;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n  color: gtGrayDark;\n  opacity: 0.7;\n  &:hover {\n    cursor: pointer;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"colors": `"styles/colors.css"`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"docLink": `styles__docLink___RU6c2 ${___CSS_LOADER_ICSS_IMPORT_1___.locals["docLink"]}`,
	"icon": `styles__icon___xVwIL`
};
export default ___CSS_LOADER_EXPORT___;
